import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';
import { deleteProduct } from '../../services/ProductService';

const DeleteConfirmModal = ({ open, onClose, onDelete, product }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleDeleteProduct = async () => {
    setLoading(true);
    try {
      await deleteProduct(product.id);
      onDelete();
    } catch (error) {
      console.error('Error deleting product:', error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  if (!product) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('confirm_deletion')}</DialogTitle>
      <DialogContent>
        <Typography>{t('delete_product_confirmation', { name: product.name })}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <LoadingButton
          loading={loading}
          onClick={handleDeleteProduct}
          variant="contained"
          color='error'
        >
          {t('delete')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmModal;
